export interface BtnProps {
  text: string;
  width?: string;
  onClick?:
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => any)
    | (() => any)
    | undefined;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  color?: string;
  bg?: string;
  loadingColor?: string;
  type?: "submit" | "button" | "reset" | undefined;
  children?: any;
}

export interface IconBtnProps extends BtnProps {
  icon: string;
  bg?: string;
  color?: string;
}

export type DetailType = {
  icon: string;
  title: string;
  desc: string;
};
export interface InputProps {
  footer?: string;
  label?: string;
  bg?: string;
  name?: string;
  onChange?: (e: any) => void;
  setState?: (e: any) => void;
  // onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value?: string;
  readonly?: boolean;
  type?: string;
  options?: any[];
  noFormat?: any;
}

export interface InputWithIconProps extends InputProps {
  icon?: string;
}

export interface IconBtnProps extends BtnProps {
  icon: string;
  bg?: string;
  color?: string;
  active?: boolean;
  disabled?: boolean;
}

export const effectivenessList = [
  "Effective",
  "Moderately Effective",
  "Ineffective",
  "Don’t Know",
] as const;

export type EffectivenessType = (typeof effectivenessList)[number];

export const informationCollectionToolList = [
  "Paper Based",
  "Paper Based with Digital Integration",
  "In-House Digital Tool",
  "Open Digital Tool",
  "Proprietary Digital Tool",
  "Mobile App",
  "Web Based Survey",
  "Sensors and IoT Devices",
  "Don’t Know",
] as const;

export type InformationCollectionToolType =
  (typeof informationCollectionToolList)[number];

export const oftenCollectedList = [
  "Daily",
  "Weekly",
  "Monthly",
  "Quarterly",
  "Annually",
] as const;

export type OftenCollectedType = (typeof oftenCollectedList)[number];

export const systemInformAreaList = [
  "Budgets",
  "Tariffs",
  "Compliance",
  "Enforcement",
  "Urban Sanitation Coverage",
  "Urban Water Coverage",
  "Rural Sanitation Coverage",
  "Rural Water Coverage",
  "Water Quality",
  "Service Reliability",
  "Technical / Asset Management",
  "Commercial / Customer Satisfaction",
  "Human Resource",
  "Efficiency",
] as const;

export type SystemInformAreaType = (typeof systemInformAreaList)[number];

export const systemInformKPIList = [
  "Utility Budget Variance",
  "National budget disbursements",
  "Cost Coverage by Revenue",
  "No of non-compliance/ Compliance failures",
  "Percentage compliance after directives",
  "%tage at least basic access (Urban Sanitation)",
  "%tage at least basic access (Urban Water)",
  "%tage at least basic access (Rural Sanitation)",
  "Hours of supply",
  "Asset health index",
  "Utilisation of treatment facilities",
  "Customer satisfaction index",
  "Complaints Resolution",
  "Metering ratio",
  "Staff/1000 WS connections",
  "Staff Cost",
  "NRW (Non-Revenue Water)",
  "Collection Efficiency",
] as const;

export type SystemInformKPIType = (typeof systemInformKPIList)[number];

export const dataSecurityList = [
  "Minimal",
  "Basic",
  "Advanced",
  "Don’t Know",
] as const;

export type DataSecurityType = (typeof dataSecurityList)[number];

export const deptsFeedDataSystemList = [
  "IT",
  "Legal",
  "Procurement",
  "HR",
  "Finance",
  "Commercial",
  "Engineering",
] as const;

export type DeptsFeedDataSystemType = (typeof deptsFeedDataSystemList)[number];

export const dataStatus = [
  "Pending Acceptance",
  "Assessment Complete",
  "Invite Expired",
  "In Progress",
] as const;

export type Status = (typeof dataStatus)[number];

export const dataStatus2 = [
  "Pending Acceptance",
  "Rejected",
  "Accepted",
] as const;

export type Status2 = (typeof dataStatus2)[number];
